import React, { useEffect, useState } from "react";
import { Button, Text } from "components";
import Modal from "react-modal";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

function CompanyAddressAdd() {
  const [visible, setvisible] = useState(true);
  const [state, setState] = useState([]);
  const [district, setDistrict] = useState([]);
  const [addresstype, setAddressType] = useState([]);
  // const location = useLocation();
  // const customer_id = location.state?.id;
  let navigate = useNavigate();

  useEffect(() => {
    stateget();
    Districtget();
    AddressType();
  }, []);

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [erplist, setErplist] = useState([]);
  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const showActionColumn = erplist.some(
    (item) => item.erp_module_id == 4 && item.add
  );

  const State_obj = {};
  const stateget = () => {
    axios
      .post("/api/purple-fusion/state/get", State_obj, headers)
      .then((response) => {
        setState(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const Address_type = {};
  const AddressType = () => {
    axios
      .post("/api/purple-fusion/addresstype/get", Address_type, headers)
      .then((response) => {
        setAddressType(response.data);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const District_obj = {};
  const Districtget = () => {
    axios
      .post("/api/purple-fusion/district/get", District_obj, headers)
      .then((response) => {
        setDistrict(response.data);
        // console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const validationSchema = Yup.object().shape({
    address_type_id: Yup.string().required("Please Select the Address Type"),
    addressline1: Yup.string()
      .required("Address Line1 is required")
      .min(1, "Address Line1 must be at least 1 character")
      .max(80, "Address Line1 must be at most 80 characters"),
    addressline2: Yup.string()
      .required("Address Line2 is required")
      .min(1, "Address Line2 must be at least 1 character")
      .max(80, "Address Line2 must be at most 80 characters"),
    state_id: Yup.string().required("Please Select the State"),
    district_id: Yup.string().required("Please Select the District"),
    city: Yup.string().required("City is Required"),
    pincode: Yup.string()
      .matches(/^\d{6}$/, "PIN code must be 6 digit")
      .required("PIN code is Required"),
    mobilenumber: Yup.string()
      .matches(/^[0-9]{10}$/, "Mobile Number must be exactly 10 digits")
      .required("Mobile Number is Required"),
    emailid: Yup.string()
      .email()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email" // Custom error message if the pattern doesn't match
      )
      .required("Email is Required"),
  });

  const formik = useFormik({
    initialValues: {
      address_type_id: "",
      addressline1: "",
      addressline2: "",
      state_id: "",
      district_id: "",
      city: "",
      pincode: "",
      mobilenumber: "",
      emailid: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  const filteredDistricts = district.filter((resDistrict) => {
    if (resDistrict.state_id == formik.values.state_id) {
      return resDistrict;
    }
    return "";
  });

  const handleFormSubmit = (values) => {
    console.log(values);

    axios
      .post("/api/purple-fusion/companyaddress/create", values, headers)
      .then((response) => {
        console.log(response.data);
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
              autoClose: 2000,
              onClose: () => {
                setvisible(false);
                navigate(`/companysettingsall`);
              },
            })
          : toast.error(message, {
              autoClose: 2000,
              onClose: () => {},
            });
      })
      .catch((error) => {
        console.log(error);
        setvisible(false);
        navigate("*");
      });
  };
  const customStyle = {
    content: {
      width: "70%",
      height: "70%",
      margin: "auto",
      borderRadius: "10px",
    },

    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      // zIndex: 999,
    },
  };
  return (
    <div>
      {showActionColumn ? (
        <div>
          <Modal isOpen={visible} style={customStyle} onRequestClose={() => {}}>
            <form onSubmit={formik.handleSubmit}>
              <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
                <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
                  <div className="flex flex-1 flex-col gap-[19px] justify-start md:px-5 w-full">
                    <div>
                      <div className="flex flex-row items-center my-1 justify-start ">
                        <div className="flex flex-row  items-start justify-between w-full ">
                          <Text
                            className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px]"
                            size="txtInterMedium24"
                          >
                            Add New Company Address
                          </Text>
                        </div>
                        <div className="flex flex-row items-center justify-end ml-auto top-2 ">
                          <Button
                            className="cursor-pointer font-medium mb-1.5 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px] active:scale-90 transition-transform duration-200"
                            shape="round"
                            color="blue_A700"
                            size="base"
                            variant="fill"
                            type="submit"
                          >
                            Save
                          </Button>
                          <Button
                            className="cursor-pointer font-medium mb-3 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px]"
                            shape="round"
                            color="white"
                            size="base"
                            variant="fill"
                            type="button"
                            onClick={() => {
                              setvisible(false);
                              navigate(`/companysettingsall`);
                            }}
                          >
                            ╳
                          </Button>
                        </div>
                      </div>
                      <ToastContainer />
                      <div className="flex flex-col items-center justify-start w-full text-sm">
                        <div className="md:gap-5  grid md:grid-cols-2 grid-cols-3 gap-x-4 gap-y-8 justify-center min-h-[auto] w-full ">
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-samll text-sm">
                                Address Type
                              </span>
                              <span className="text-red-A700 font-inter font-samll text-sm">
                                *
                              </span>
                            </Text>
                            <Select
                              name="address_type_id"
                              options={addresstype.map((resstate) => ({
                                label: resstate.name,
                                value: resstate.id,
                              }))}
                              className="bg-white-A700 border border-gray-200_02 border-solid h-9rounded-[5px] w-full text-xs"
                              onChange={(selectedOption) => {
                                formik.setFieldValue(
                                  "address_type_id",
                                  selectedOption.value
                                );
                              }}
                              onBlur={formik.handleBlur}
                              placeholder="Select Address Type"
                            />
                            {formik.touched.address_type_id &&
                            formik.errors.address_type_id ? (
                              <div className="text-red-500 text-sm">
                                {formik.errors.address_type_id}
                              </div>
                            ) : null}
                          </div>
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full ">
                            <Text
                              className=" md:text-[22px] text-black-900 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Address Line1
                              </span>
                              <span className="text-red-A700 font-inter font-samll text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="addressline1"
                              type="text"
                              placeholder=" Enter Address"
                              value={formik.values.addressline1}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full text-xs"
                            ></input>
                            {formik.touched.addressline1 &&
                            formik.errors.addressline1 ? (
                              <div className="text-red-500 text-sm">
                                {formik.errors.addressline1}
                              </div>
                            ) : null}
                          </div>
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black900"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Address Line2
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="addressline2"
                              type="text"
                              placeholder=" Enter Address "
                              value={formik.values.addressline2}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full text-xs"
                            ></input>
                            {formik.touched.addressline2 &&
                            formik.errors.addressline2 ? (
                              <div className="text-red-500 text-sm">
                                {formik.errors.addressline2}
                              </div>
                            ) : null}
                          </div>
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-samll text-sm">
                                State
                              </span>
                              <span className="text-red-A700 font-inter font-samll text-sm">
                                *
                              </span>
                            </Text>
                            <Select
                              name="state_id"
                              options={state.map((resstate) => ({
                                label: resstate.name,
                                value: resstate.id,
                              }))}
                              className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full text-xs"
                              onChange={(selectedOption) => {
                                formik.setFieldValue(
                                  "state_id",
                                  selectedOption.value
                                );
                              }}
                              onBlur={formik.handleBlur}
                              placeholder="Select State"
                            />
                            {formik.touched.state_id &&
                            formik.errors.state_id ? (
                              <div className="text-red-500 text-sm">
                                {formik.errors.state_id}
                              </div>
                            ) : null}
                          </div>
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium24Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                District
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <Select
                              name="district_id"
                              options={filteredDistricts.map((resstate) => ({
                                label: resstate.name,
                                value: resstate.id,
                              }))}
                              className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full text-xs"
                              onChange={(selectedOption) => {
                                formik.setFieldValue(
                                  "district_id",
                                  selectedOption.value
                                );
                              }}
                              onBlur={formik.handleBlur}
                              placeholder="Select District"
                            />
                            {formik.touched.district_id &&
                            formik.errors.district_id ? (
                              <div className="text-red-500 text-sm">
                                {formik.errors.district_id}
                              </div>
                            ) : null}
                          </div>
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className="md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                City
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="city"
                              type="text"
                              placeholder=" Enter City"
                              value={formik.values.city}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="bg-white-A700 border  border-gray-400_02 border-solid h-9 rounded-[5px] w-full text-xs"
                            ></input>
                            {formik.touched.city && formik.errors.city ? (
                              <div className="text-red-500 text-sm">
                                {formik.errors.city}
                              </div>
                            ) : null}
                          </div>
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium24Black700"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Pincode
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="pincode"
                              type="text"
                              placeholder=" Enter Pincode"
                              value={formik.values.pincode}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full text-xs"
                            ></input>
                            {formik.touched.pincode && formik.errors.pincode ? (
                              <div className="text-red-500 text-sm">
                                {formik.errors.pincode}
                              </div>
                            ) : null}
                          </div>
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black900"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Mobile Number
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="mobilenumber"
                              type="number"
                              placeholder=" Enter Mobile Number"
                              value={formik.values.mobilenumber}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full text-xs"
                            ></input>
                            {formik.touched.mobilenumber &&
                            formik.errors.mobilenumber ? (
                              <div className="text-red-500 text-sm">
                                {formik.errors.mobilenumber}
                              </div>
                            ) : null}
                          </div>
                          <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                            <Text
                              className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                              size="txtInterMedium20Black900"
                            >
                              <span className="text-black-700 font-inter font-small text-sm">
                                Email
                              </span>
                              <span className="text-red-A700 font-inter font-small text-sm">
                                *
                              </span>
                            </Text>
                            <input
                              name="emailid"
                              placeholder=" Enter Email example@gmail.com"
                              value={formik.values.emailid}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="bg-white-A700 border  border-gray-400_02 border-solid h-9 rounded-[5px] w-full text-xs"
                            ></input>
                            {formik.touched.emailid && formik.errors.emailid ? (
                              <div className="text-red-500 text-sm">
                                {formik.errors.emailid}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Modal>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </div>
  );
}

export default CompanyAddressAdd;
